import React, { useMemo } from 'react';

import { Pagination } from '@lucidhq/lucidium';

import { getPageSizes } from '~/utils/pagination';

import { useIPMatchingContext } from './IPMatchingProvider';

export const IPMatchingPagination = () => {
  const {
    page,
    setPage,
    setPageSize,
    pageSize,
    ipMatching
  } = useIPMatchingContext();

  const totalItems = useMemo(() => ipMatching?.total_items || 0, [
    ipMatching?.total_items
  ]);

  return (
    <Pagination
      page={page}
      pageSize={pageSize}
      adjacentPages={2}
      total={totalItems}
      pageSizes={getPageSizes(totalItems)}
      onChange={({ page: incomingPage, pageSize: incomingPageSize }) => {
        if (incomingPage !== 0 && page !== incomingPage) {
          setPage(incomingPage as number);
        }
        if (incomingPageSize !== 0 && pageSize !== incomingPageSize) {
          setPageSize(incomingPageSize as number);
        }
      }}
    />
  );
};
